import { Component } from '@angular/core';
import { FileStatus } from '@app/core/model/file-status';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-file-status-renderer',
  templateUrl: './file-status-renderer.component.html',
  styleUrls: ['./file-status-renderer.component.scss']
})
export class FileStatusRendererComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public status: string = FileStatus.ACTIVE;
  public helpText: string = null;
  public showHelpText: boolean = false;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.status = FileStatus.getFileStatus(params && params.data);
    this.helpText = FileStatus.getFileStatusHelpText(params && params.data);
    this.showHelpText = this.status === FileStatus.EXTERNALLY_MODIFIED && this.helpText !== this.status;
  }

  public refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
